"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateErrorWithDetail = exports.getURL = void 0;
const constants_1 = require("../constants");
function getURL(baseURL, path, orgId) {
    if (routeToGateway(baseURL)) {
        if (!isValidOrg(orgId)) {
            throw new Error('A valid Org id is required for this operation');
        }
        return `${baseURL}/hidden/orgs/${orgId}/code${path}`;
    }
    return `${baseURL}${path}`;
}
exports.getURL = getURL;
function routeToGateway(baseURL) {
    return baseURL.includes('snykgov.io');
}
function isValidOrg(orgId) {
    return orgId !== undefined && constants_1.ORG_ID_REGEXP.test(orgId);
}
function generateErrorWithDetail(error, statusCode, apiName) {
    var _a;
    const errorLink = (_a = error.links) === null || _a === void 0 ? void 0 : _a.about;
    const detail = `${error.title}${error.detail ? `: ${error.detail}` : ''}${errorLink ? ` (more info: ${errorLink})` : ``}`;
    const statusText = error.title;
    return {
        type: 'error',
        error: {
            apiName,
            statusCode: statusCode,
            statusText,
            detail,
        },
    };
}
exports.generateErrorWithDetail = generateErrorWithDetail;
//# sourceMappingURL=httpUtils.js.map